import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import SelectChannel from '../../components/SelectChannel.vue'
import Pagination from '@/components/Pagination.vue'
import { useRoute,useRouter } from 'vue-router'
import { useStore } from '@/store'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'OutLog',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute() as any
    const filters = reactive({
            coupon_id:'',//总库券包id
            out_batch:'',//批次
            ds_coupon_id:'',//总库券包id
            name:'',//卡号
            channel_no:         '',  //渠道出库情况 
            add_start_date:         '',   // 出库开始时间
            add_end_date:           '',   // 出库结束时间
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
            spanArr: [],
            pos: 0,

    })
    const tableData = ref([])
    const total = ref(0)
    const store = useStore()
    const out = (type) => {
        window.open(`${Keys.baseUrl}/coupon/offline_coupon/warehouseOutAllList?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
    }
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/coupon/offline_coupon/warehouseOutAllList', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
            filters.spanArr = data.data
            getSpanArr(filters.spanArr)

        })
    }
    const getSpanArr = (resData) => {
        filters.spanArr = []
        if (resData === null) {
            return
        }
        for (let i = 0; i < resData.length; i++) {
            if (i === 0) {
                //@ts-ignore
                filters.spanArr.push(1)
                filters.pos = 0
            } else {
                if (resData[i].out_batch === resData[i - 1].out_batch) {
                    //@ts-ignore
                    filters.spanArr[filters.pos] += 1
                    //@ts-ignore
                    filters.spanArr.push(0)
                } else {
                    resData[i].hasClass = true
                    //@ts-ignore
                    filters.spanArr.push(1)
                    filters.pos = i
                }
            }
        }
    }
    const objectSpanMethod = ({ row, column, rowIndex, columnIndex }) => {
        let columnArray = [1]
        if (columnArray.includes(columnIndex)) {
            const row = filters.spanArr[rowIndex]
            const col = row > 0 ? 1 : 0
            return {
                rowspan: row,
                colspan: col
            }
        }
    }
    // 合并后的表格添加样式
    const rowClassName= ({ row }) => {
        if (row.hasClass) {
            return 'deep-border'
        }
    }
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.out_batch,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.out_batch) = $event)),
        modelModifiers: { trim: true },
        placeholder: "出库批次",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.coupon_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.coupon_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券包id",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.ds_coupon_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.ds_coupon_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "平台券包id",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.add_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库开始时间",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.add_end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.add_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "出库结束时间",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (out(1)))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      "span-method": objectSpanMethod,
      "row-class-name": rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "out_batch",
          label: "出库批次"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_id",
          label: "券包id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "out_type",
          label: "出库情况"
        }),
        _createVNode(_component_el_table_column, {
          prop: "num",
          label: "数量"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "渠道结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "jiesuan_price",
          label: "结算金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "出库时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "admin_name",
          label: "申请人"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(`/coupon-iso/coupon-list?out_batch=${scope.row.out_batch}`))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})